/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seat_Change_Light_LimitsInputs */



/**
* | output |
* | --- |
* | "With a Light seat they use the included AI model only and can't create agents, projects, spaces or API keys." |
*
* @param {Seat_Change_Light_LimitsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const seat_change_light_limits = /** @type {((inputs?: Seat_Change_Light_LimitsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seat_Change_Light_LimitsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Mit einem Light-Platz nutzt das Mitglied nur das enthaltene KI-Modell und kann keine Agenten, Projekte, Spaces oder API-Schlüssel erstellen.")
	return /** @type {LocalizedString} */ ("With a Light seat they use the included AI model only and can't create agents, projects, spaces or API keys.")
});